import { Navigate, RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

import InvoiceScreen from './invoices/InvoiceScreen';
import { PaymentLinksScreen } from './payment-links/PaymentLinksScreen';
import PayoutsScreen from './payouts/PayoutsScreen';
import BillingSettingsScreen from './settings/BillingSettingsScreen';

export const invoiceRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="invoices" />,
  },
  {
    path: 'invoices',
    element: <InvoiceScreen />,
  },
  {
    path: 'settings',
    element: <BillingSettingsScreen />,
  },
  {
    path: 'payouts',
    element: <PayoutsScreen />,
  },
  {
    path: 'payment-links',
    element: <PaymentLinksScreen />,
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute
        routePath="/billing/invoices"
        linkText="Go back to invoices"
      />
    ),
  },
];
